import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modal
import RequestDocumentModal from "../modals/RequestDocumentModal";

const DocumentRequestForm = () => {
  const routes = all_routes;
  const [requestType, setRequestType] = useState("");

  // Mock data for testing
  const documentTypes = [
    {
      id: 1,
      name: "Transfer Certificate",
      description: "Certificate for school transfer",
    },
    {
      id: 2,
      name: "Character Certificate",
      description: "Character reference certificate",
    },
    {
      id: 3,
      name: "Bonafide Certificate",
      description: "Proof of enrollment certificate",
    },
    {
      id: 4,
      name: "Mark Sheet",
      description: "Academic transcript/marks statement",
    },
    {
      id: 5,
      name: "Fee Receipt",
      description: "Duplicate fee payment receipt",
    },
  ];

  const mockRequests = [
    {
      id: 1,
      type: "Transfer Certificate",
      status: "Pending",
      date: "2024-07-18",
      expectedDate: "2024-07-25",
      trackingId: "REQ-2024-001",
    },
    {
      id: 2,
      type: "Bonafide Certificate",
      status: "Approved",
      date: "2024-07-15",
      expectedDate: "2024-07-20",
      trackingId: "REQ-2024-002",
    },
    {
      id: 3,
      type: "Mark Sheet",
      status: "Rejected",
      date: "2024-07-10",
      expectedDate: "N/A",
      trackingId: "REQ-2024-003",
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Approved":
        return "badge-soft-success";
      case "Pending":
        return "badge-soft-warning";
      case "Rejected":
        return "badge-soft-danger";
      case "Processing":
        return "badge-soft-info";
      default:
        return "badge-soft-secondary";
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Student Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Document Request</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Quick Stats */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-file-text"></i>
                    </div>
                    <div>
                      <h4>{mockRequests.length}</h4>
                      <p className="text-muted mb-0">Total Requests</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-clock"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockRequests.filter((r) => r.status === "Pending")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockRequests.filter((r) => r.status === "Approved")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Approved</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-danger-transparent me-3">
                      <i className="ti ti-x"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockRequests.filter((r) => r.status === "Rejected")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Rejected</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Main Content */}
            <div className="col-lg-8">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Request New Document</h4>
                  <div>
                    <button
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#requestDocumentModal"
                    >
                      <i className="ti ti-plus me-2"></i>New Request
                    </button>
                  </div>
                </div>

                {/* TODO Placeholders */}
                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6>
                      <i className="ti ti-info-circle me-2"></i>TODO: Connect to
                      document request API
                    </h6>
                    <ul className="mb-0">
                      <li>Submit document request to database</li>
                      <li>Send notification to admin</li>
                      <li>Upload supporting files to storage</li>
                      <li>Generate tracking ID</li>
                    </ul>
                  </div>
                </div>

                {/* Request History */}
                <div className="card-body">
                  <h5 className="mb-3">My Document Requests</h5>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Request ID</th>
                          <th>Document Type</th>
                          <th>Submitted</th>
                          <th>Expected</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockRequests.map((request) => (
                          <tr key={request.id}>
                            <td>{request.trackingId}</td>
                            <td>{request.type}</td>
                            <td>{request.date}</td>
                            <td>{request.expectedDate}</td>
                            <td>
                              <span
                                className={`badge ${getStatusColor(
                                  request.status
                                )}`}
                              >
                                {request.status}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <button className="btn btn-sm btn-outline-primary">
                                  <i className="ti ti-eye"></i>
                                </button>
                                {request.status === "Pending" && (
                                  <button className="btn btn-sm btn-outline-warning">
                                    <i className="ti ti-edit"></i>
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* Document Info */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Available Documents</h5>
                </div>
                <div className="card-body">
                  {documentTypes.map((type) => (
                    <div key={type.id} className="mb-3 p-2 border rounded">
                      <h6 className="mb-1">{type.name}</h6>
                      <p className="text-muted mb-2 small">
                        {type.description}
                      </p>
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-success">Fee: $5</small>
                        <small className="text-muted">7-10 days</small>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Help & Support */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Need Help?</h5>
                </div>
                <div className="card-body">
                  <p className="text-muted mb-3">
                    Contact the administration office for assistance:
                  </p>
                  <div className="d-grid gap-2">
                    <button className="btn btn-outline-success btn-sm">
                      <i className="ti ti-phone me-1"></i>Call Office
                    </button>
                    <button className="btn btn-outline-info btn-sm">
                      <i className="ti ti-mail me-1"></i>Send Email
                    </button>
                  </div>
                </div>
              </div>

              {/* Quick Tips */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Important Notes</h5>
                </div>
                <div className="card-body">
                  <ul className="mb-0">
                    <li className="mb-2">
                      Processing times are business days only
                    </li>
                    <li className="mb-2">Rush fees are non-refundable</li>
                    <li className="mb-2">All requests require verification</li>
                    <li>Email confirmation will be sent</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <RequestDocumentModal />
    </>
  );
};

export default DocumentRequestForm;
